import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { AccessibleOutlineCSS } from "@faire/retailer-visitor-shared/components/AccessibleOutlineCSS";
import { DEPRECATED_backwardsCompatibleValues } from "@faire/web--source/common/localization/localize";
import { Add } from "@faire/web--source/slate/icons/foundation/Add";
import { Subtract } from "@faire/web--source/slate/icons/foundation/Subtract";
import { MeasurementInput } from "@faire/web--source/slate/Input/MeasurementInput";
import { Row } from "@faire/web--source/slate/Layout";
import { Tooltip } from "@faire/web--source/slate/Tooltip";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import styled from "styled-components";
export var OpenSizingVariationInput = function(param) {
    var variation = param.variation, onChange = param.onChange;
    var label = variation.size;
    var value = variation.selectedQuantity;
    var disabled = variation.inventory === 0;
    var quantityThreshold = variation.inventory;
    var inputError = quantityThreshold !== 0 && value > quantityThreshold;
    var handleSubtractValue = function() {
        return onChange(value - 1);
    };
    var handleAddValue = function() {
        return onChange(value + 1);
    };
    var handleCustomValue = function(value) {
        return onChange(value !== null && value !== void 0 ? value : 0);
    };
    return /*#__PURE__*/ _jsxs(Row, {
        align: "center",
        gap: "1x",
        children: [
            /*#__PURE__*/ _jsx(IconButton, {
                onClick: handleSubtractValue,
                disabled: disabled,
                children: /*#__PURE__*/ _jsx(Subtract, {})
            }),
            /*#__PURE__*/ _jsx(Tooltip, {
                isOpen: true,
                hidden: !inputError,
                width: 120,
                targetNode: /*#__PURE__*/ _jsx(StyledNumberInput, {
                    precision: 0,
                    value: disabled ? 0 : value,
                    onChange: handleCustomValue,
                    disabled: disabled,
                    error: inputError,
                    "data-test-id": "open-sizing-size-quantity-".concat(label)
                }),
                children: /*#__PURE__*/ _jsx(Typography, {
                    color: "inherit",
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "usj6m5",
                        defaultMessage: [
                            {
                                type: 6,
                                value: "quantityThreshold",
                                options: {
                                    one: {
                                        value: [
                                            {
                                                type: 0,
                                                value: "Only "
                                            },
                                            {
                                                type: 7
                                            },
                                            {
                                                type: 0,
                                                value: " piece left"
                                            }
                                        ]
                                    },
                                    other: {
                                        value: [
                                            {
                                                type: 0,
                                                value: "Only "
                                            },
                                            {
                                                type: 7
                                            },
                                            {
                                                type: 0,
                                                value: " pieces left"
                                            }
                                        ]
                                    }
                                },
                                offset: 0,
                                pluralType: "cardinal"
                            }
                        ],
                        values: DEPRECATED_backwardsCompatibleValues({
                            quantityThreshold: quantityThreshold
                        })
                    })
                })
            }),
            /*#__PURE__*/ _jsx(IconButton, {
                onClick: handleAddValue,
                disabled: disabled,
                children: /*#__PURE__*/ _jsx(Add, {})
            })
        ]
    });
};
var IconButton = styled.button.withConfig({
    componentId: "sc-8236704b-0"
})([
    "display:flex;align-items:center;justify-content:center;width:30px;height:30px;",
    " &:hover{background:",
    ";}&:disabled{background-color:",
    ";color:",
    ";cursor:default;}"
], AccessibleOutlineCSS, Core.surface.subdued, Core.surface.inverse, Core.border.muted);
var StyledNumberInput = styled(MeasurementInput).withConfig({
    componentId: "sc-8236704b-1"
})([
    "width:44px;height:30px;padding:0;input{text-align:center;}"
]);
